import { components, SingleValueProps } from 'react-select';
import { SelectOptionData } from '@/components/SelectFloatingLabel/SelectFloatingLabel';

const SingleValue = ({ children, ...props }: SingleValueProps<SelectOptionData>) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

export default SingleValue;
